/** Client-owned copy for successful Design Scope updates (ignore API message). */
export const DESIGN_SCOPE_UPDATE_SUCCESS_MESSAGE = "Updated Successfully.";

/** Client-owned copy for successful Design Scope deletes (ignore API message). */
export const DESIGN_SCOPE_DELETE_SUCCESS_MESSAGE = "Deleted Successfully.";
